module.exports = __webpack_public_path__ + "static/media/chemistry@2x.4daa5a17.png";